<template>
  <div class="testType">
  <van-nav-bar title="基本信息" class="main-nav" />
  <div class="content" v-loading="loading" element-loading-text="数据加载中...">
  <div class="tip_area">
    <div class="box_tip">
      <div class="kid_cartoon"></div>
      <div class="text_area">
        <p>尊敬的家长：</p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;您好！欢迎来到智育心桥，在您首次使用本产品之前，需要先填写一些基本信息，以便我们为您提供更好的服务。填写完成后即可使用本产品的所有功能。祝您使用愉快！</p>
      </div>
    </div>
  </div>
  <van-form @submit="onSubmit" validate-trigger="onSubmit">
  <div class="parentsInfor">
    <div class="title">家长信息</div>
    <div class="centerBg">
      <van-field
        v-model="parentName"
        :required="true"
        :rules="[{ required: true, message: '' }]"
        name="家长姓名"
        label="家长姓名"
        placeholder="请输入"
        label-align="right"
      />
      <van-field
        v-model="sex"
        :required="true"
        :rules="[{ required: true, message: '' }]"
        name="sex"
        label="家长性别"
        placeholder="请选择"
        label-align="right"
        type="number"
        @click="checkedSex"
      >
        <template #input>
          <van-radio-group v-model="sex" direction="horizontal">
            <van-radio name="1">男</van-radio>
            <van-radio name="2">女</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        readonly
        v-model="phone"
        :required="true"
        name="phone"
        type="number"
        label="家长手机号"
        placeholder="请输入"
        maxlength="11"
        label-align="right"
        :rules="[
								{ required: true, message: '' },
								{ pattern: /^1[3456789]\d{9}$/, message: '手机号码格式错误！'}
							]"
        @blur="checkedPhone"
      />
      <!--						<van-field-->
      <!--							v-model="parentIdCard"-->
      <!--							name="parentIdCard"-->
      <!--							label="家长身份证号"-->
      <!--							placeholder="请输入"-->
      <!--							label-align="right"-->
      <!--							maxlength='18'-->
      <!--							@blur="checkedIdCard(1)"-->
      <!--						/>-->
      <van-field
        readonly
        clickable
        :required="true"
        :rules="[{ required: true, message: '' }]"
        name="datetimePicker"
        :value="birthday"
        label="家长出生日期"
        placeholder="请选择"
        label-align="right"
        @click="selectBirth(1)"
      >
        <template #button>
          <van-icon name="notes-o" color="#FF8340" size="20" />
        </template>
      </van-field>
      <van-field
        readonly
        v-model="age"
        name="age"
        :required="true"
        :rules="[{ required: true, message: '' }]"
        label="家长年龄"
        placeholder="请输入"
        label-align="right"
        type="number"
        maxlength="3"
      />
      <!--						<van-field-->
      <!--							readonly-->
      <!--							clickable-->
      <!--							name="datetimePicker"-->
      <!--							:value="region"-->
      <!--							label="所在地"-->
      <!--							placeholder="请输入"-->
      <!--							label-align="right"-->
      <!--							@click="showToolbar=true"-->
      <!--						>-->
      <!--							<template #button>-->
      <!--								<van-icon name="arrow" size="16"/>-->
      <!--							</template>-->
      <!--						</van-field>-->
      <!--            <van-field-->
      <!--              v-model="street"-->
      <!--              name="详细地址"-->
      <!--              label="详细地址"-->
      <!--              placeholder="请输入"-->
      <!--              label-align="right"-->
      <!--            />-->
    </div>
  </div>
  <div class="childrenInfor">
    <div class="title">儿童信息</div>
    <div class="name" v-for="(item,index) in studentList" :key="index">
      <p class="studentName" v-if="studentList.length > 1">儿童{{ index + 1 }}</p>
      <div class="centerBg">
        <van-icon
          name="cross"
          class="delete"
          v-if="studentList.length > 1"
          @click="deleteOne(index)"
        />
        <div class="relationship">
          <van-field
            readonly
            v-model="item.relation"
            name="relation"
            :required="true"
            :rules="[{ required: true, message: '' }]"
            label="与儿童的关系"
            placeholder="请选择"
            label-align="right"
            maxlength="11"
            @click.stop="showRelation(item)"
          >
            <template #button>
              <img src="../../assets/images/basic-infor/open.png" class="open" alt="">
            </template>
          </van-field>
          <van-popup v-model="item.showRelationship" round position="bottom">
            <van-picker
              show-toolbar
              :columns="classList"
              @cancel="item.showRelationship = false"
              @confirm="relationship($event,item)"
            />
          </van-popup>
        </div>
        <van-field
          v-model="item.studentNo"
          name="儿童的编码"
          label="儿童的编码"
          placeholder="请输入"
          type="number"
          maxlength="40"
          label-align="right"
          @blur="matchParent(item,'0',index)"
          :disabled="item.disabled"
        />
        <van-field
          v-model="item.studentName"
          :required="true"
          :rules="[{ required: true, message: '' }]"
          name="studentName"
          label="儿童姓名"
          placeholder="请输入"
          maxlength="5"
          label-align="right"
          @blur="matchParent(item,'1',index)"
        />
        <van-field
          v-model="item.sex"
          :required="true"
          :rules="[{ required: true, message: '' }]"
          name="sex"
          label="儿童性别"
          placeholder="请选择"
          label-align="right"
          type="number"
        >
          <template #input>
            <van-radio-group
              v-model="item.sex"
              direction="horizontal"
              @change="matchParent(item,'1',index)"
            >
              <van-radio name="1">男</van-radio>
              <van-radio name="2">女</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <!--						<van-field-->
        <!--							v-model="item.idCard"-->
        <!--							name="idCard"-->
        <!--							label="儿童身份证号"-->
        <!--							placeholder="请输入"-->
        <!--							label-align="right"-->
        <!--							maxlength='19'-->
        <!--							@blur="checkedIdCard(item)"-->
        <!--						/>-->
        <van-field
          readonly
          clickable
          :required="true"
          :rules="[{ required: true, message: '' }]"
          name="datetimePicker"
          :value="item.birthday"
          label="儿童出生日期"
          placeholder="请选择"
          label-align="right"
          @click="selectBirth(2,item.id)"
        >
          <template #button>
            <van-icon name="notes-o" color="#FF8340" size="20" />
          </template>
        </van-field>
        <div class="school">
          <van-field
            v-model="item.school"
            name="school"
            :required="true"
            :rules="[{ required: true, message: '' },{validator:(v)=>scoolValidator(v,item),message: '请从检索结果中选择所在学校',trigger:'onChange'}]"
            label="儿童学校名称"
            placeholder="请输入学校名称"
            label-align="right"
            maxlength="20"
            autocomplete="off"
            @blur="handleClose(item)"
            @input="schoolSearch(item)"
          >
          </van-field>
          <div class="schoolList" v-show="item.showSchool && schoolList.length>0">
            <div v-for="(ite,ind) in schoolList" :key="ind">
              <p @click="selectSchool(ite,item,index)">{{ ite.name }}</p>
            </div>
          </div>
        </div>
        <div class="studentsClass">
          <div class="studentsClass_top">
            <van-field
              readonly
              :required="true"
              :rules="[{ required: true, message: '' }]"
              clickable
              name="gender"
              :value="item.gender"
              label="儿童班级"
              placeholder="选择年级"
              label-align="right"
              @click.prevent.stop="showGenderBtn(item)"
            >
              <template #button>
                <van-icon name="arrow-down" size="16" />
              </template>
            </van-field>
            <van-popup v-model="item.showGender" round position="bottom">
              <van-picker
                show-toolbar
                :columns="classList"
                @cancel="item.showGender = false"
                @confirm="selectGender($event,item,index)"
              />
            </van-popup>
          </div>
          <div class="theClass">
            <van-field
              readonly
              placeholder="选择班级"
              :value="item.className"
              class="wi80"
              @click.prevent.stop="showClassBtn(item)"
            />
            <van-icon name="arrow-down" size="16" />
            <van-popup v-model="item.showClass" round position="bottom">
              <van-picker
                show-toolbar
                :columns="classList"
                @cancel="item.showClass = false"
                @confirm="selectClass($event,item,index)"
              />
            </van-popup>
          </div>
        </div>
        <div class="addStudents" @click="addStudents" v-if="index==studentList.length-1">
          <p>新增儿童</p>
        </div>
      </div>
    </div>
  </div>
  <van-button
    class="submitBtn"
    round
    block
    type="info"
    native-type="submit"
  >提交
  </van-button>
  </van-form>
  </div>
  <!-- 选择日期弹窗 -->
  <van-popup v-model="showPicker" position="bottom">
    <van-datetime-picker
      v-model="currentDate"
      type="date"
      title="选择年月日"
      :min-date="minDate"
      :max-date="maxDate"
      @confirm="onConfirm"
      @cancel="showPicker = false"
    />
  </van-popup>
  <!-- 选择地区弹框 -->
  <!--		<van-popup v-model="showToolbar" position="bottom">-->
  <!--			<van-area-->
  <!--        title="地域"-->
  <!--        :value="cityId"-->
  <!--				:area-list="areaList"-->
  <!--        :columns-num="3"-->
  <!--        @cancel="showToolbar=false"-->
  <!--        @confirm='confirmRegion'-->
  <!--      />-->
  <!--		</van-popup>-->
  <!-- 匹配孩子信息，绑定家长 -->
  <van-overlay :show="showDialog" style="height: calc(100%)" :lock-scroll="false">
    <div class="register-code">
      <div class="informedConsent">
        <div style="display: flex;">
          <p class="p18">提示</p>
          <van-icon name="cross" size="20" class="closePop" @click="closePop" />
        </div>
        <div v-if="flag" class="content" style="margin-bottom:70px" v-html="toolTips">11</div>
        <div v-else style="padding-bottom:70px">
          <div class="content">为了信息隐私,需要您验证已绑定人:{{ bindUserName }}的信息</div>
          <van-form :label-width="80" label-align="right" @submit="bindSubmit">
            <div style="padding: 0 20px;">
              <van-field
                v-model="bindForm.name"
                name="姓名"
                label="姓名："
                placeholder="请输入已绑定人姓名"
                :rules="[{ required: true }]"
              />
              <van-field
                v-model="bindForm.phone"
                type="number"
                name="联系方式"
                label="联系方式："
                placeholder="请输入已绑定人联系方式"
                :rules="[{ required: true }]"
              />
            </div>
            <div class="btn">
              <van-button class="code_btn left_btn" @click="flag = true">
                返回
              </van-button>
              <van-button
                class="code_btn right_btn"
                round
                block
                type="info"
                native-type="submit"
              >
                绑定
              </van-button>
            </div>
          </van-form>
        </div>
        <div class="btn" v-if="flag">
          <van-button class="code_btn left_btn" @click="showDialog=false">
            否
          </van-button>
          <van-button class="code_btn right_btn" @click="flag = false">
            是
          </van-button>
        </div>
      </div>
    </div>
  </van-overlay>
  </div>
</template>
<script>
import {
  _basicInfo,
  _invokeList,
  _invokeTree,
  _getStudentListByParentPhone,
  _getParentBasicInfoByParentPhone,
  _birthdayAndAgeAndSigns,
  _schoolSearch,
  _matchParent,
  _bindParent,
} from '../../api/home';
import { areaList } from '@vant/area-data';
import { decryptBy } from '@/assets/js/encryption';
import { ages } from '@/assets/js/util';

export default {
  name: 'basic-information',
  data() {
    return {
      areaList,
      parentName: '',// 家长姓名
      sex: 1,//性别 1 男 2 女
      phone: '',// 家长联系方式
      // parentIdCard:'',// 家长身份证
      birthday: '',// 家长出生日期
      showPicker: false,// 出生日期弹窗
      minDate: new Date(1900, 0, 1),// 最小日期
      // maxDate: new Date(2014,0,7),// 最大日期
      currentDate: new Date(),// 当前日期
      type: 1,// 组件使用者
      birthdayType: 0, //
      code: 'class',
      relationList: [],// 选择与孩子的关系
      age: '',// 家长年龄
      // showToolbar:false,// 是否展示选择第区
      areaObj: [],
      // region:'',//地区
      cityId: '110000',//默认城市码
      gender: '1',//性别 1 男 2 女
      // province:'',// 省份
      // provinceCode:'',// 省份编码
      // city:'',// 城市
      // cityCode:'',// 城市编码
      // county:'',// 区县
      // countyCode:'',// 区县编码
      // street:'',//详细地址
      loading: false, //加载
      studentList: [
        {
          id: 0,// 标识
          studentId: '', //儿童id
          showSchool: false,// 显示学校选择器
          showClass: false,// 显示班级选择器
          showRelationship: false,//
          relation: '',// 与孩子的关系
          relationNo: '',// 关系编码
          showGender: false,//显示班级选择器
          studentNo: '',//儿童编码
          studentName: '',// 儿童姓名
          sex: 1, // 儿童性别
          // idCard:'',// 儿童身份证号
          birthday: '',// 儿童出生日期
          school: '', // 儿童学校名称
          schoolNo: '', // 学校编号
          gender: '',// 儿童年级
          genderNo: '',// 年级编号
          className: '',// 儿童班级
          classNameNo: '',// 班级编号
          disabled: false, //儿童编码是否可编辑
        },
      ],// 儿童信息
      showGender: false,//显示班级选择器
      schoolList: [],//选择学校
      schoolListSele: [],//选择学校
      gradeList: [],//选择年级
      classList: [],//选择班级
      showDialog: false,//匹配弹窗
      flag: true,
      index: 0,
      toolTips: '',
      bindUserName: '',
      bindForm: {
        name: '',
        phone: '',
        studentId: '',
      },
      selectionSchoolHistory: {},
    };
  },
  created() {
    // this.phone = JSON.parse(localStorage.getItem("userInfo")).mobilePhone;
    let info = localStorage.getItem('userInfo');
    let user = JSON.parse(decryptBy(info));
    this.phone = decryptBy(user.mobilePhoneStr);
    this.getParentBasicInfoByParentPhone();
    this.getStudentListByParentPhone();
  },
  computed: {
    maxDate() {
      let now = new Date();
      let nowYear = now.getFullYear() - 8;
      let nowDay = now.getDate();
      let newMonth = now.getMonth();
      if (this.type == 1) {
        return new Date();
      } else {
        return new Date(nowYear, newMonth, nowDay);
      }

    },
  },
  methods: {
    scoolValidator(val, item) {
      let find = this.selectionSchoolHistory[item.id] || false;
      return (find && item.schoolNo == find.schoolNo && item.school == find.school);
    },
    // 选择出生日期弹框
    selectBirth(val, id) {
      this.showPicker = true;
      this.type = val;
      if (id + '') {
        this.birthdayType = id;
      }
    },
    // 选择出生日期
    onConfirm(value, index) {
      if (this.type == 1) {
        this.birthday = this.formatDate(value);
        this.age = ages(this.birthday);
      } else {
        for (let i = 0; i < this.studentList.length; i++) {
          if (this.studentList[i].id == this.birthdayType) {
            this.studentList[i].birthday = this.formatDate(value);
            this.matchParent(this.studentList[i], '1', i);
          }
        }
      }
      this.showPicker = false;
    },
    //格式化日期
    formatDate(val) {
      var y = val.getFullYear();
      var m = val.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = val.getDate();
      d = d < 10 ? '0' + d : d;
      return y + '-' + m + '-' + d;
    },
    // 选择家长性别
    checkedSex() {
    },
    // 手机号码失焦事件
    checkedPhone() {
      this.getStudentListByParentPhone();
    },
    // 展示选择关系弹窗
    showRelation(item) {
      this.code = 'relationShip';
      this.invokeList();
      // 打开窗口值取反
      item.showRelationship = !item.showRelationship;
    },
    // 选择与孩子的关系
    relationship(value, item) {
      item.relation = value;
      for (let i = 0; i < this.gradeList.length; i++) {
        const element = this.gradeList[i];
        if (item.relation === element.name) {
          item.relationNo = element.code;
        }
      }
      item.showRelationship = false;
      // 隐藏弹框
    },
    // 展示选择年级
    showGenderBtn(item) {
      this.code = 'grade';
      this.invokeList();
      item.showGender = true;
    },
    // 展示选择班级
    showClassBtn(item) {
      this.code = 'class';
      this.invokeList();
      item.showClass = true;

    },
    // 学校失焦事件
    handleClose(item) {
      // 隐藏弹框
      setTimeout(() => {
        item.showSchool = false;
      }, 200);
    },
    // 选择地区
    // confirmRegion(val){
    // 	this.province = val[0].name;
    // 	this.provinceCode = val[0].code;
    // 	this.city = val[1].name;
    // 	this.cityCode = val[1].code;
    // 	this.county = val[2].name;
    // 	this.countyCode = val[2].code;
    // 	this.showToolbar = false;
    // 	this.region = this.province +"-"+ this.city +"-"+ this.county;
    // },
    // 选择年级
    selectGender(value, item, index) {
      item.gender = value;
      for (let i = 0; i < this.gradeList.length; i++) {
        const element = this.gradeList[i];
        if (item.gender === element.name) {
          item.genderNo = element.code;
        }
      }
      // 隐藏弹框
      this.matchParent(item, '1', index);
      item.showGender = false;
    },
    // 选择班级
    selectClass(value, item, index) {
      item.className = value;
      for (let i = 0; i < this.gradeList.length; i++) {
        const element = this.gradeList[i];
        if (item.className === element.name) {
          item.classNameNo = element.code;
        }
      }
      // 隐藏弹框
      this.matchParent(item, '1', index);
      item.showClass = false;
    },
    // 选择学校
    selectSchool(ite, item, index) {
      item.school = ite.name;
      item.schoolNo = ite.schoolCode;
      // 隐藏弹框
      item.showSchool = false;
      this.selectionSchoolHistory[item.id] = {
        id: item.id,
        school: ite.name,
        schoolNo: ite.schoolCode,
      }
      this.matchParent(item, '1', index);
    },
    // 删除该儿童
    deleteOne(index) {
      this.studentList.splice(index, 1);
    },
    // 添加儿童
    addStudents() {
      let timestamp = new Date().getTime();
      let obj = {
        id: timestamp,
        showSchool: false,// 显示学校选择器
        showClass: false,// 显示班级选择器
        showRelationship: false,//
        relation: '',// 与孩子的关系
        relationNo: '',// 关系编码
        showGender: false,//显示班级选择器
        studentNo: '',//儿童编码
        studentName: '',// 儿童姓名
        sex: 1, // 儿童性别
        // idCard:'',// 儿童身份证号
        birthday: '',// 儿童出生日期
        school: '', // 儿童学校名称
        schoolNo: '', // 学校编号
        gender: '',// 儿童年级
        genderNo: '',// 年级编号
        className: '',// 儿童班级
        classNameNo: '',// 班级编号
        disabled: false, //儿童编码是否可编辑
      };
      this.studentList.push(obj);
    },
    // 选择学校
    schoolSearch(item) {
      item.showSchool = true;
      this.schoolList = [];

      _schoolSearch({
        keywords: item.school,
        audit: 1,// 0代表检索所有的学校，1-代表检索审核通过的学校
      }).then((res) => {
        if (res && res.code == 200) {
          if (res.data) {
            this.schoolList = res.data;
          }
        } else {
          this.$toast(res.message);
        }
      });
    },
    // 获取数据
    invokeList() {
      this.loading = true;
      _invokeList({
        code: this.code,
      }).then((res) => {
        if (res.code && res.code == 200) {
          this.classList = [];
          this.gradeList = res.data;
          for (let i = 0; i < res.data.length; i++) {
            const element = res.data[i];
            this.classList.push(element.name);
          }
          this.loading = false;
        } else {
          this.$toast(res.message);
          this.loading = false;
        }
      });
    },
    // 获取省市区列表
    // invokeTree(){
    // 	const areaList = {
    // 		province_list: {},
    // 		city_list: {},
    // 		county_list: {},
    // 	};
    // 	_invokeTree().then((res)=>{
    // 		if(res.code && res.code==200){
    //
    // 		}else {
    // 			this.$toast(res.message);
    // 		}
    // 	})
    // },
    /**
     * 身份证验证
     */
    // validator (val) {
    //   const card15 = /^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}[0-9Xx]$/
    //   const card18 = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
    //   return card15.test(val) || card18.test(val) || ''
    // },
    // 身份证失焦自动获取年龄，生日
    // checkedIdCard (item){
    // 	let idCard;
    // 	if (item === 1) {
    // 		idCard = this.parentIdCard;
    // 	}else {
    // 		idCard = item.idCard;
    // 	}
    // 	if (!idCard) {
    // 		return
    // 	}
    // 	if (!this.validator (idCard)) {
    // 		this.$toast('请输入正确身份证号');
    // 		return false
    // 	}
    // 	_birthdayAndAgeAndSigns(idCard).then((res)=>{
    // 		if(res.code && res.code==200){
    // 			if (item === 1) {
    // 				this.birthday = res.data.birthday;
    // 				this.age = res.data.age;
    // 			}else {
    // 				item.birthday = res.data.birthday;
    // 			}
    // 		}else {
    // 			this.$toast(res.message)
    // 		}
    // 	})
    // },
    // 根据手机号匹配信息
    getStudentListByParentPhone() {
      _getStudentListByParentPhone({
        phone: this.phone,
      }).then((res) => {
        if (res && res.code == 200) {
          if (res.data.length) {
            for (let i = 0; i < res.data.length; i++) {
              const element = res.data[i];
              element.studentId = element.id;
              element.showRelationship = false;
              element.showGender = false;
              element.showSchool = false;
              element.showClass = false;
              res.data[0].id = 0;
              this.studentList.push(element);
            }
            this.studentList = res.data;
          }
        } else {
          this.$toast(res.message);
        }
      });
    },
    // 根据手机号匹配信息
    getParentBasicInfoByParentPhone() {
      _getParentBasicInfoByParentPhone({
        phone: this.phone,
      }).then((res) => {
        if (res && res.code == 200) {
          if (res.data) {
            this.parentName = res.data.parentName;
            this.sex = res.data.sex;
            this.birthday = res.data.birthday;
            this.city = res.data.city;
            this.cityCode = res.data.cityCode;
            this.county = res.data.county;
            this.countyCode = res.data.countyCode;
            this.parentIdCard = res.data.idCard;
            this.province = res.data.province;
            this.provinceCode = res.data.provinceCode;
            this.age = res.data.age;
            this.street = res.data.street;
            // 当所在有值的时候
            if (this.province && this.city && this.county) {
              this.region = this.province + '-' + this.city + '-' + this.county;
            } else {
              this.region = '';
            }

          }
        } else {
          this.$toast(res.message);
        }
      });
    },
    matchParent(item, type, index) {
      if (item.studentNo && type == '0') {
        item.verificationMethod = 0;
        this.matchFun(item);
      } else if (!item.studentNo && item.studentName && item.sex && item.birthday &&
        item.schoolNo && item.genderNo && item.classNameNo) {
        item.verificationMethod = 1;
        this.matchFun(item);
      }
      this.index = index;
    },
    matchFun(data) {
      _matchParent(data).then(res => {
        if (res.data && res.data.popupFlag == 1) {
          this.showDialog = true;
          this.toolTips = res.data.toolTips;
          this.bindUserName = res.data.bindUserName;
          this.bindForm.studentId = res.data.studentId;
        }
      }).catch(err => {
        throw err;
      }).finally(() => {

      });
    },
    bindSubmit() {
      _bindParent(this.bindForm).then(res => {
        if (res.code == 200) {
          if (res.data) {
            if (res.data.verificationFlag == 1) {
              this.$toast('绑定成功');
              let list = deepClone(this.studentList);
              list[this.index] = res.data.basicInfo;
              list[this.index].relation = this.studentList[this.index].relation;
              list[this.index].relationNo = this.studentList[this.index].relationNo;
              list[this.index].showRelationship = false;
              list[this.index].showGender = false;
              list[this.index].showClass = false;
              list[this.index].disabled = true;
              list[this.index].studentId = res.data.basicInfo.id;
              this.currentDate = new Date(res.data.basicInfo.birthday);
              this.studentList = list;
              this.showDialog = false;
              setTimeout(() => {
                this.flag = true;
                this.bindForm = {
                  name: '',
                  phone: '',
                  studentId: '',
                };
              }, 500);
            } else {
              this.$toast('信息不匹配，请重新输入');
            }
          }
        }
      }).catch(err => {
        throw err;
      }).finally(() => {
      });
    },
    // 关闭匹配弹窗
    closePop() {
      this.showDialog = false;
      setTimeout(() => {
        this.flag = true;
      }, 500);
    },
    // 提交
    onSubmit() {
      // if (!this.validator (this.parentIdCard) && this.parentIdCard) {
      // 	this.$toast('请输入正确身份证号');
      // 	return false
      // }
      let parentInfo = {
        age: this.age,
        sex: this.sex,
        birthday: this.birthday,
        // idCard:this.parentIdCard,
        parentName: this.parentName,
        phone: this.phone,
        // province:this.province,
        // provinceCode:this.provinceCode,
        // city:this.city,
        // cityCode:this.cityCode,
        // county:this.county,
        // countyCode:this.countyCode,
        // street:this.street,
      };
      let studentList = [];
      let nameList = [];
      let codeList = [];
      for (let i = 0; i < this.studentList.length; i++) {
        const element = this.studentList[i];
        if (!element.className) {
          this.$toast('请输入班级');
          return false;
        }
        if (!element.schoolNo) {
          element.school = '';
          this.$toast('请输入正确学校名称');
          return false;
        }
        for (let j = 0; j < this.schoolList.length; j++) {
          const el = this.schoolList[j];
          if (element.school == el.name) {
            nameList.push(el.schoolCode);
            if (nameList.indexOf(element.schoolNo) == -1) {
              this.$toast('请输入正确学校名称');
              return false;
            }
            // if (element.schoolNo !== el.schoolCode) {
            // 	this.$toast('请输入正确学校名称');
            // 	return false
            // }
          } else if (element.schoolNo == el.schoolCode) {
            let codeList = [];
            codeList.push(el.name);
            if (codeList.indexOf(element.school) == -1) {
              this.$toast('请输入正确学校名称');
              return false;
            }
            // if(element.school !== el.name) {
            // 	this.$toast('请输入正确学校名称');
            // 	return false
            // }
          }
        }
        // if (!this.validator (element.idCard) && element.idCard) {
        // 	this.$toast('请输入正确身份证号');
        // 	return false
        // }
        let arr = {
          birthday: this.studentList[i].birthday,
          className: this.studentList[i].className,
          classNameNo: this.studentList[i].classNameNo,
          gender: this.studentList[i].gender,
          genderNo: this.studentList[i].genderNo,
          // idCard:this.studentList[i].idCard,
          relation: this.studentList[i].relation,
          relationNo: this.studentList[i].relationNo,
          school: this.studentList[i].school,
          schoolNo: this.studentList[i].schoolNo,
          sex: this.studentList[i].sex,
          studentName: this.studentList[i].studentName,
          studentNo: this.studentList[i].studentNo,
          studentId: this.studentList[i].studentId,
        };
        studentList.push(arr);
      }
      _basicInfo({
        parentInfo: parentInfo,
        studentList: studentList,
      }).then((res) => {
        if (res.code && res.code == 200) {
          this.$router.replace('/');
        } else {
          this.$toast(res.message);
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep .van-cell {
  height: 45px;
}

::v-deep .van-field__error-message {
  margin-top: -10px;
}

.testType {
  background: url(../../assets/images/basic-infor/basic-bg.png);
  background-size: 100%;
  padding: 40px 0 0;

  .main-nav {
    position: fixed;
    top: 0;
    width: 100%;
  }

  .title {
    color: #FF8340;
    padding: 10px 10px;
  }

  .content {
    width: 100%;
    padding: 10px;

    .tip_area {
      margin-top: 45px;

      .box_tip {
        position: relative;
        width: 345px;
        height: 160px;
        background: url("../../assets/images/basic-infor/bg-text.png") no-repeat;
        background-size: cover;
        display: flex;
        justify-content: center;
        align-items: center;

        .kid_cartoon {
          position: absolute;
          right: -5%;
          top: -25%;
          width: 122px;
          height: 79px;
          background: url("../../assets/images/basic-infor/info-girl.png") no-repeat;
          background-size: cover;
        }

        .text_area {
          width: 301px;
          height: 140px;

          p {
            font-size: 16px;
            color: #FFF;
            line-height: 24px;
          }
        }
      }
    }

    .name:nth-child(2) {
      .studentName {
        margin-top: 0;
      }
    }

    .name {
      .centerBg {
        border-radius: 0px 16px 16px 16px;
        margin-bottom: 20px;
      }
    }

    .centerBg {
      padding: 10px 0;
      width: 100%;
      max-height: 420px;
      background: #FFF;
      border-radius: 16px;

      .delete {
        position: relative;
        top: 3px;
        right: -326px;
      }

      .open {
        width: 16px;
      }
    }

    .studentName {
      padding: 2px;
      text-align: center;
      width: 58px;
      height: 26px;
      background: #FFF;
      border-radius: 6px 6px 0px 0px;
      margin-top: 10px;
      color: #FF8340;
    }

    .addStudents {
      width: 100%;
      font-size: 14px;
      color: #FF8340;
      line-height: 50px;
      padding: 0 20px;
    }
  }

  .school {
    position: relative;

    .schoolList {
      position: absolute;
      top: 50px;
      right: 6px;
      height: 112px;
      background-color: #FFF;
      width: 245px;
      padding: 0 20px;
      border: 1px solid #DDD;
      overflow: scroll;
      line-height: 30px;
      z-index: 22;
      box-shadow: 0px 2px 4px 0px rgba(201, 201, 201, 0.5);
      border-radius: 8px;
      font-size: 14px;
    }
  }

  .studentsClass {
    height: 46px;
    display: flex;

    .studentsClass_top {
      width: 230px;
      display: flex;
      align-items: center;
    }

    .theClass {
      width: 120px;
      display: flex;
      align-items: center;

      .wi80 {
        width: 100px;
        // ::v-deep.van-field__control{
        // 	margin-top: -10px;
        // }
      }
    }

    .gradeList {
      padding: 5px;
      line-height: 30px;
    }

    // ::v-deep.van-field__control{
    // 	margin-top: -20px;
    // }
    ::v-deep .van-cell--required {
      height: 46px;
    }
  }

  .submitBtn {
    width: 160px;
    height: 40px;
    background: linear-gradient(360deg, #FF7F30 0%, #FFBC97 100%);
    border-radius: 20px;
    font-size: 15px;
    border: none;
    margin: 20px auto;
  }
}

.register-code {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

// .consent_h {
// height: 24% !important;
// }
.informedConsent {
  // height: 36%;
  width: 315px;
  background: #FFF;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
  // justify-content: center;
  position: relative;

  p {
    padding: 0 0 0 20px;
    color: #000;
    margin: 16px 0;
    font-size: 16px;
    font-weight: 800;
  }

  .closePop {
    margin-top: 10px;
    position: absolute;
    right: 5px;
  }

  .content {
    padding: 0;
    line-height: 30px;
    color: #666;
    padding: 0 20px;
  }

  .btn {
    position: absolute;
    bottom: 0;
    display: flex;
    width: 100%;

    .code_btn {
      border: none;
      width: 50%;
      height: 50px;
      color: #FFF;
    }

    .left_btn {
      border-radius: 0 0 0 5px;
      background-color: #CDC9C9;
    }

    .right_btn {
      background: #FF8400;
      border-radius: 0 0 5px 0;
    }
  }
}
</style>
